module.exports = __webpack_public_path__ + "img/ame.daa5b25.png";